import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hrishikesh-karmarkar',
  templateUrl: './hrishikesh-karmarkar.component.html',
  styleUrls: ['./hrishikesh-karmarkar.component.scss']
})
export class HrishikeshKarmarkarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
